import { selectionConfigService as apiSelectionConfigService } from './api';
import { Option } from '../types/mold';

/**
 * Registry of entity types to their create option functions
 * This makes it easy to extend for new entities
 */
export const createOptionRegistry: Record<string, (value: string) => Promise<Option>> = {
  'mold.partMatGradeList': apiSelectionConfigService.createPartMatGradeOption,
};

/**
 * Get the create option function for a given entity type
 */
export const getCreateOptionFunction = (entityType: string): ((value: string) => Promise<Option>) | undefined => {
  return createOptionRegistry[entityType];
};
